import { Box, CircularProgress } from '@mui/material';

export const InfiniteScrollLoader = () => {
  return (
    <Box
      key={0}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 2,
        paddingBottom: 2,
        width: '100%',
      }}
    >
      <CircularProgress disableShrink />
    </Box>
  );
};
